export default __webpack_public_path__ + "static/map_scr-b8ed6f39660bde893752a989abcdb91b.png";